export const maxWidth = "1500px";
